import { useLocale } from "@calcom/lib/hooks/useLocale";
import { trpc } from "@calcom/trpc";
import { Button, Form, showToast, TextField } from "@calcom/ui";
import { Trans } from "next-i18next";
import { useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";

type FormValues = {
  name?: string;
  email: string;
};

export function EmailForm({
  isEmbed,
  sendOtpSuccess,
}: {
  isEmbed?: boolean;
  sendOtpSuccess: (email: string, name?: string) => void;
}) {
  const { t, i18n } = useLocale();
  const [loading, setLoading] = useState(false);

  const methods = useForm<FormValues>();
  const { register } = methods;

  const sendOtp = trpc.viewer.auth.sendOtp.useMutation({
    onSuccess: (_, variables) => {
      sendOtpSuccess(variables.email, methods.getValues("name"));
      showToast(t("verification_code_sent"), "success");
    },

    onError: (err) => {
      setLoading(false);

      if (err.data?.code === "TOO_MANY_REQUESTS") {
        showToast(t("too_many_requests"), "error");
      } else {
        showToast(t("failed_to_send_code"), "error");
      }
    },
  });

  const handleEmailSubmit: SubmitHandler<FormValues> = async (data) => {
    setLoading(true);

    const normalizedEmail = data.email.toLowerCase().trim();

    sendOtp.mutate({ email: normalizedEmail, language: i18n.language });
  };

  return (
    <>
      <Form form={methods} handleSubmit={handleEmailSubmit}>
        <div className="space-y-4">
          {!isEmbed && (
            <TextField
              {...register("name")}
              label={t("name") + " (" + t("optional") + ")"}
              type="text"
              placeholder="John Doe"
            />
          )}

          <TextField
            {...register("email")}
            label={t("email_address")}
            type="email"
            required
            placeholder="you@example.com"
          />
        </div>

        <Button type="submit" color="primary" className="mt-6 w-full justify-center" loading={loading}>
          {t("continue")}
        </Button>
      </Form>
      <p className="mt-8 text-center text-xs leading-relaxed text-gray-500">
        <Trans t={t} i18nKey="sign_up_agreement">
          {"By signing up, you agree to our "}
          <a
            href="https://www.luckybrunch.de/allgemeine-geschaftsbedingungen"
            target="_blank"
            rel="noopener noreferrer"
            className="text-brand-700 underline underline-offset-2">
            General Terms and Conditions
          </a>
          {" and our "}
          <a
            href="https://www.luckybrunch.de/datenschutzerklaerung"
            target="_blank"
            rel="noopener noreferrer"
            className="text-brand-700 underline underline-offset-2">
            Privacy Policy
          </a>
          .
        </Trans>
      </p>
    </>
  );
}
